import { clsx } from "clsx";
import type { IDialogSectionProps } from "./types";

/** Scrolls when the content is taller than the panel. */
export const DialogBody = ({ className, children }: IDialogSectionProps) => (
  <div className={clsx("nuco-dialog__body", className)}>{children}</div>
);

export const DialogFooter = ({ className, children }: IDialogSectionProps) => (
  <footer className={clsx("nuco-dialog__footer", className)}>{children}</footer>
);
